import { useEffect, useState } from "react";
import { TODOS_EMPREENDIMENTOS_VALUE } from "../utils/empreendimentoSelector";

const pageEmpresaSelection = new Map();
const SHARED_EMPRESA_SELECTION_KEY = "__agente_contabilidade_last_empresa__";

function getOptionSelectionKey(option) {
  return String(
    option?.selectionKey ||
      option?.context?.idClienteEmpresa ||
      option?.idClienteEmpresa ||
      option?.value ||
      ""
  ).trim();
}

function findOptionBySelection(empresaOptions = [], selection) {
  const normalizedSelection = String(selection || "").trim();
  if (!normalizedSelection) {
    return null;
  }

  return empresaOptions.find((option) => {
    return (
      String(option.value || "").trim() === normalizedSelection ||
      getOptionSelectionKey(option) === normalizedSelection
    );
  }) || null;
}

export function resolveEmpresaSelection(selectedEmpresa, empresaOptions = [], preferredSelection = "") {
  if (!empresaOptions.length) {
    return selectedEmpresa || "";
  }

  const companyOptions = empresaOptions.filter(
    (option) => option.value !== TODOS_EMPREENDIMENTOS_VALUE
  );
  if (!companyOptions.length) {
    return "";
  }

  const preferredOption = findOptionBySelection(empresaOptions, preferredSelection);
  if (preferredOption) {
    return preferredOption.value;
  }

  const selectedOption = findOptionBySelection(empresaOptions, selectedEmpresa);
  if (selectedOption) {
    return selectedOption.value;
  }

  return companyOptions[0]?.value || "";
}

export function usePageEmpresaSelection(pageKey, empresaOptions = []) {
  const [selectedEmpresa, setSelectedEmpresaState] = useState(
    () => pageEmpresaSelection.get(pageKey) || ""
  );

  useEffect(() => {
    if (selectedEmpresa) {
      pageEmpresaSelection.set(pageKey, selectedEmpresa);
    } else {
      pageEmpresaSelection.delete(pageKey);
    }
  }, [pageKey, selectedEmpresa]);

  useEffect(() => {
    if (!selectedEmpresa || !empresaOptions.length) {
      return;
    }

    const selectedOption = findOptionBySelection(empresaOptions, selectedEmpresa);
    if (selectedOption) {
      pageEmpresaSelection.set(
        SHARED_EMPRESA_SELECTION_KEY,
        getOptionSelectionKey(selectedOption)
      );
    }
  }, [empresaOptions, selectedEmpresa]);

  useEffect(() => {
    if (!empresaOptions.length) {
      return;
    }

    const resolvedSelection = resolveEmpresaSelection(
      selectedEmpresa,
      empresaOptions,
      pageEmpresaSelection.get(SHARED_EMPRESA_SELECTION_KEY)
    );
    if (resolvedSelection !== selectedEmpresa) {
      setSelectedEmpresaState(resolvedSelection);
    }
  }, [empresaOptions, selectedEmpresa]);

  return [selectedEmpresa, setSelectedEmpresaState];
}
